import { useCallback, useEffect, useState, useSyncExternalStore } from 'react'
import { httpConnection } from '../lib/httpConnection'
import { connectionBannerMessage, HTTP_CONNECTION_NOTICE_MS } from '../lib/connectionStatus'
import { useBrowserOnline } from './useBrowserOnline'
import { useOnForeground } from './useOnForeground'

/** Native uses actual HTTP failures/slowness; web also supplies offline state. */
export function useHttpConnectionNotice(gameId: string | undefined): string | null {
  const subscribe = useCallback((listener: () => void) => httpConnection.subscribe(gameId ?? '', listener), [gameId])
  const read = useCallback(() => httpConnection.snapshot(gameId ?? ''), [gameId])
  const snapshot = useSyncExternalStore(subscribe, read, read)
  const online = useBrowserOnline()
  const [foregroundAt, setForegroundAt] = useState(() => Date.now())
  const [now, setNow] = useState(() => Date.now())
  useOnForeground(() => { const time = Date.now(); setForegroundAt(time); setNow(time) })
  useEffect(() => {
    setNow(Date.now())
    const starts = [snapshot.oldestRequestAt, snapshot.failureSince].filter((start): start is number => start !== null)
    if (!starts.length) return
    const due = Math.max(Math.min(...starts), foregroundAt) + HTTP_CONNECTION_NOTICE_MS
    const timer = setTimeout(() => setNow(Date.now()), Math.max(0, due - Date.now()))
    return () => clearTimeout(timer)
  }, [snapshot, foregroundAt])
  return connectionBannerMessage({ offline: !online, snapshot, now, foregroundAt })
}
